import { useState } from 'react'
import attributeDictionaryValuesService from '../../../services/attributeDictionaryValuesService'
import {
  AttributeDictionaryValue,
  LayerAttributeDictionary,
  LayerAttributeDictionaryValue
} from '../../../services/models'
import { DictionaryUi } from './types'

// Хранит загруженные значения словарей, режим «показать всё» и строку поиска.
// Создаётся один раз на страницу и передаётся во все карточки групп: данные
// ключуются по id словаря и одинаковы для любого слоя.
export const useDictionaryUi = (): DictionaryUi => {
  const [values, setValues] = useState<{ [k: number]: AttributeDictionaryValue[] }>({})
  const [showMore, setShowMore] = useState<{ [k: number]: boolean }>({})
  const [search, setSearchState] = useState<{ [k: number]: string }>({})

  const setSearch = (id: number, value: string) => {
    setSearchState(old => ({ ...old, [id]: value }))
  }

  const toggleShowMore = (id: number) => {
    if (showMore[id]) {
      setShowMore(old => ({ ...old, [id]: false }))
      return
    }
    if (values[id] !== undefined) {
      setShowMore(old => ({ ...old, [id]: true }))
      return
    }
    attributeDictionaryValuesService.getById(id).then((response) => {
      setValues(old => ({ ...old, [id]: response.attributeDictionaryValues }))
      setShowMore(old => ({ ...old, [id]: true }))
    })
  }

  const optionsFor = (ad: LayerAttributeDictionary): LayerAttributeDictionaryValue[] => {
    if (!showMore[ad.id]) return ad.values ?? []
    const loaded: LayerAttributeDictionaryValue[] = values[ad.id] ?? []
    const query = (search[ad.id] || '').trim().toLowerCase()
    if (query === '') return loaded
    return loaded.filter(v => v.name.toLowerCase().indexOf(query) !== -1)
  }

  return { values, showMore, search, setSearch, toggleShowMore, optionsFor }
}
